import { DayPicker } from "react-day-picker";

import "react-day-picker/style.css";
import "./styles.scss";

const CustomDatePickerModal = ({
  visible,
  onClickBackdrop,
  selected,
  onSelect,
  disabled,
}) => {
  return (
    <div
      className={`date-picker-modal ${visible ? "show" : "hide"}`}
      onClick={onClickBackdrop}
    >
      <div
        className="date-picker-content"
        onClick={event => event.stopPropagation()}
      >
        <DayPicker
          animate
          mode="single"
          selected={selected}
          onSelect={onSelect}
          disabled={disabled}
        />
      </div>
    </div>
  );
};

export default CustomDatePickerModal;
